export const apiPath = {
  // wuji
  numberSystemList: '/api/number-system-list',
  tip: '/api/tip',
  tag: '/api/tag',
  aiUsage: '/api/ai-usage',
  feedback: '/api/feedback',
};

export const apiPathServer = {
  // 列表
  spaceList: '/space_list',
  storyList: '/story_list',
  propsList: '/itemcard_list',
  sceneList: '/web/api/scene-list',
  fullSceneList: '/scene_list',
  botList: '/bot_list',
  botOptions: '/scene_edit/bot_list',
  botListByStory: '/bot_list_by_story',
  botListBySpace: '/bot_list_by_space',
  cardList: '/web/api/card-list',
  knowledgeList: '/get_bot_knowledge_list',
  voiceList: '/get_bot_voice_list',
  emoticonList: '/get_bot_emoticon_list',
  skillList: '/get_bot_skill_list',
  templateList: '/templete_list',
  tagList: '/get_bot_tags_list',
  CAImodelList: '/get_bot_model_list',
  VENUSmodelList: '/get_venus_model_list',
  userSig: '/GetUserSig',
  getBots: '/bots',
  promotionList: '/homedata/list',
  plazaList: '/rolesquare/list',
  materialList: '/list',
  chapterList: '/chapter_list',

  // 获取下载地址
  materialDownload: '/download',

  // 修改用户信息
  postUserInfo: '/user/submit_audit',
  getUserInfo: '/user/get_audit_info',

  // 智能创作
  generateMission: '/mission_fillin',
  generateBot: '/bot_fillin',

  // 异步任务
  asyncExtractColor: '/async/extract_color',
  asyncTranscode: '/media_upload',
  getAsyncTaskProcess: '/get_process_media_by_taskId',

  // 详情
  spaceDetail: '/space_detail',
  chapterDetail: '/chapter_detail',
  storyDetail: '/story_detail',
  sceneDetail: '/scene_detail',
  botDetail: '/bot_detail',
  cardDetail: '/card_detail',
  missionDetail: '/mission_detail',
  eventDetail: '/event_detail',
  propsDetail: '/itemcard_detail',
  promotionItemDetail: '/homedata/item/detail',
  promotionDetail: '/homedata/detail',
  plazaDetail: '/rolesquare/detail',
  materialDetail: '/get',
  plazaItemDetail: '/rolesquare/item/detail',
  gamePlayDetail: '/ai_game_play_detail',

  // 故事线
  storyLine: '/GetStoryLine',
  getSceneSelection: '/GetSceneSelection',

  // 画布
  mapDetail: '/get_chapter_draw',
  postMap: '/save_chapter_draw',

  // 获取App故事广场首页
  getHomeData: '/GetHomeData',

  // 获取绑定信息
  getBindInfo: '/GetUnionIds',

  // 新增&编辑&状态变更
  postSpace: '/space_post',
  postBot: '/bot_post',
  postStory: '/story_post',
  postScene: '/scene_post',
  postCard: '/card_post',
  postMission: '/mission_post',
  postEvent: '/event_post',
  postProps: '/itemcard_post',
  postKnowledge: '/knowledge_post',
  postPromotionItem: '/homedata/item/save',
  postPromotion: '/homedata/save',
  postPlaza: '/rolesquare/save',
  postMaterial: '/post',
  postPlazaItem: '/rolesquare/item/save',
  postChapter: '/chapter_post',

  // 删除
  deleteSpace: '/space_delete',
  deleteStory: '/story_delete',
  deleteScene: '/scene_delete',
  deleteBot: '/bot_delete',
  deleteCard: '/card_delete',
  deleteMission: '/mission_delete',
  deleteProps: '/itemcard_delete',
  deletePromotion: '/homedata/delete',
  deletePlaza: '/rolesquare/delete',
  deleteMaterial: '/delete',
  deleteIntimacy: '/numsys_delete',
  deleteBotMemory: '/ClearSingleChatMessage',
  deleteChapter: '/chapter_delete',

  // 更新
  updatePromotionFields: '/homedata/update_fields',
  updatePlazaFields: '/rolesquare/update_usage',
  updateCondtions: '/update_scene_pass_conditions',
  updateFirstScene: '/update_first_scene',
  updateGamePlay: '/ai_game_play_post',

  // 审核
  submitStory: '/submit_story',
  submitBot: '/submit_bot',

  // 获取预览故事二维码
  getStoryPreview: '/GenSharePreview',
  getBindQrcode: '/GenUnionQRCode',

  // 复制
  copy: '/copy',
  copyBot: '/copy_bot',
  copyPromotion: '/homedata/copy',
  copyPlaza: '/rolesquare/copy',

  // 排序
  sort: '/show_index_post',

  // 取色
  getColor: '/extract_color',

  // 获取cos临时密钥
  getCosKey: '/get_cos_sts',
  checkResourceExist: '/check_story_resource_exist',
  setResource: '/set_story_resource',

  // aigc
  aiDrawing: '/ai_txt2_image',
  getAIResource: '/get_ai_resource',
  deleteAIResource: '/delete_ai_resource',
  fetchModels: '/fetch_models',
  polishPrompt: '/polish_prompt',
  getTasksByID: '/get_asyctasks_by_id',
  removeBackground: '/remove_background',
  outPaint: '/outpainting',
  aiMusic: '/ai_txt2_music',
  getMusicByID: '/GetMusicByTaskID',
  aiVoice: '/tts/gen_voice',
  aiVideo: '/ai_gen_video',

  // 绘本
  getBookList: '/get_book_list',
  getBookDetail: '/get_book_detail',
  saveBook: '/save_book',
  deleteBook: '/delete_book',
  saveStoryboard: '/save_storyboard',
  copyStoryboard: '/copy_storyboard',
  deleteStoryboard: '/del_storyboard',
  genStoryboardVideo: '/gen_storyboard_video',
  textToStoryboards: '/text_to_storyboards',
  textToStoryboardVideo: '/text_storyboards_to_video',
  textToStoryboardImage: '/text_storyboards_to_img',
  reGenTextVideo: '/text_to_video',
  reGenImgVideo: '/img_to_video',
  genFinalVideo: '/gen_final_video',
  getVoiceList: '/get_minimax_voice_list',
  deleteHistory: '/history/delete_by_id',
  chooseVideo: '/history/choose_select',
  parseExcel: '/parse_excel',
  nextStep: '/next_step',
  preStep: '/pre_step',
  saveRole: '/role/save_role_info',
  getRoleList: '/role/get_role_list',

  // 登录
  GetUserInfo: '/GetUserInfo',
  Login: '/Login',
  GetWoaUserInfo: '/get_woa_identity',
  GetAuth: '/get_auth',

  // 素材库
  ListUserResourceMatch: '/userresourcev2/match_list',
  ListUserResourceV2: '/userresourcev2/list',
  ListUserResource: '/userresource/list',
  InsertUserResource: '/userresourcev2/insert',
  DeleteUserResourceBelong: '/userresourcev2/delete',
  updateUserResource: '/userresourcev2/update',

  ListUserResourceCustomGroupReq: '/userresourcev2/list_group',
  DeleteUserResourceCustomGroup: '/userresourcev2/delete_custom_group',
  InsertCustomGroup: '/userresourcev2/insert_custom_group',
  UpdateCustomGroup: '/userresourcev2/update_custom_group',
  MoveGroup: '/userresourcev2/move_group',
  SetLastViewGroup: '/userresourcev2/set_last_view_group',
  GetLastViewGroup: '/userresourcev2/get_last_view_group',

  // 获取审核意见
  GetBotCheckOpinion: '/bot/audit_failed',
  GetStoryCheckOpinion: '/story/audit_failed',
  GetStoryCount: '/get_story_resource_count',

  // 上架
  PublishStory: '/story_publish',

  // 结算
  SignCheck: '/sign_check',
  InvitedBySignAuthor: '/invited_by_sign_author',
  InvitedRecordList: '/invited_record_list',
  ContractList: '/contract_detail_list',
  ContractHistoryList: '/get_settlement_rule_list',
  CreateContactDraft: '/create_contract_draft',
  CreateContactOfficial: '/create_contract_official',
  CreateSettlement: '/insert_settlement_rule',
  RejectContract: '/audit_reject',
  DownloadContract: '/download_contract',
  SubmitContract: '/submit_contract',
  BankList: '/get_bank_list',
  CityList: '/get_bank_city_list',

  // 付费
  GetPayInfo: '/pay/get_story_payinfo',
  UpdatePayInfo: '/pay/upsert_story_payinfo',
  SubmitPayAudit: '/pay/submit_pay_audit',
  AuditPayInfo: '/pay/audit_story_payinfo',
  GetPayAuditList: '/pay/list_audit_pay_history',
  PublishPayInfo: '/pay/publish_story_payinfo',
  GetOnlinePay: '/pay/get_story_payinfo_snapshot',

  // diff
  getDiffList: '/get_diff_list',
  getSceneDiffDetail: '/get_scene_diff_detail',
  ChatSingle: '/ChatSingle',

  // 数值
  GetNumberSystemList: '/numsys_role_list',
  GetNumSysList: '/numsys_list',
  PostNumSys: '/numsys_post',
  ChangeRoleBgImage: '/numsys_role_post',
  numSysDelete: '/numsys_delete',
  GetNumChoiceSysList: '/numsys_role_choice_list',
  NumSysRoleDel: '/numsys_role_delete',
};
